import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

export const KTCheckboxStyle = {
  square: 'checkbox-square',
  rounded: 'checkbox-rounded',
  circle: 'checkbox-circle',
};

export const KTCheckboxType = {
  default: '',
  outline: 'checkbox-outline',
  accent: 'checkbox-accent',
};

KTCheckbox.propTypes = {
  // required
  name: PropTypes.string.isRequired,
  // optional
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  style: PropTypes.oneOf(Object.values(KTCheckboxStyle)),
  type: PropTypes.oneOf(Object.values(KTCheckboxType)),
  additionalClassName: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  enableCheckValid: PropTypes.bool,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  feedbackText: PropTypes.string,
};

function KTCheckbox({
  name,
  label = '',
  text = '',
  checked = false,
  disabled = false,
  large = false,
  style = KTCheckboxStyle.rounded,
  type = KTCheckboxType.default,
  additionalClassName = '',
  onChange,
  onBlur,
  onFocus,
  enableCheckValid = false,
  isTouched = false,
  isValid = true,
  feedbackText = '',
}) {
  // MARK: --- Params ---
  const [isChecked, setChecked] = useState(true);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  // MARK: --- Functions ---
  function handleChange(e) {
    const newCheckedState = !isChecked;
    setChecked(newCheckedState);
    if (onChange) {
      onChange(newCheckedState);
    }
  }

  function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  }

  function handleFocus() {
    if (onFocus) {
      onFocus();
    }
  }

  return (
    <div>
      <label
        className={`
                checkbox mb-0
                ${disabled ? 'checkbox-disabled' : ''} 
                ${large ? 'checkbox-lg' : ''}
                ${style}
                ${type}
                ${additionalClassName}
            `}
      >
        <input
          type="checkbox"
          name={name}
          disabled={disabled}
          checked={isChecked}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        <span></span>
        {label}
      </label>

      {enableCheckValid && isTouched && !isValid && !_.isEmpty(feedbackText) && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{feedbackText}</div>
        </div>
      )}
      {!_.isEmpty(text) && <span className="form-text text-muted">{text}</span>}
    </div>
  );
}

export default KTCheckbox;
